<template>
  <div class="auto-uncle-iframe">
    <!-- <img src="/imgs/autouncle_placeholder.png" widht="197" height="54" alt="AutoUncle" class="w-[197px] h-[54px]" /> -->
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped></style>
